import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Input,
    Label,
    FormGroup, CustomInput,
    Table
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { FileInput, generateFormData } from '../../../../helpers/ui/FileInput'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import { Link, useHistory, Redirect } from "react-router-dom"
import { withRouter } from "react-router";

import apiResponse from '../../../../services/apiResponse'
import Shimmer from "react-shimmer-effect";
import CustomSelect from "../../../../helpers/ui/CustomSelect"

import UpdateBloc from './Blocs/UpdateBloc'

class IndexView extends Component {

    updateBloc = new UpdateBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            totalRow : null
        }
    }

    submitData = async () => {
        const formData = generateFormData(this.state.dataForm, 'file_sp') // Jika nama field fileinputnya adalah 'File', maka parameter kedua boleh dikosongkan. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto'] 
        await this.updateBloc.fetchUpdate(formData)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                uuid: this.state.detail?.punishment_discipline_uuid,
                ...values
            },
            confirm: true
        })
        console.log(values)
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.updateBloc.updateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.updateBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        this.setState({
                            detail: response
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        const queryParams = new URLSearchParams(this.props.location.search)
        this.updateBloc.fetchDetail({uuid: queryParams.get('uuid') })
    }

    componentWillUnmount() {
        this.updateBloc.updateChannel?.unsubscribe()
        this.updateBloc.detailChannel?.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card>
                                <CardBody>
                                    <CardTitle>Upload Surat Pemanggilan</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                # Pegawai Terkena Hukuman
                                            </label>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                NIP
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.punishment_discipline_employee_nip !== "" ? this.state.detail.punishment_discipline_employee_nip : '-'}</>
                                                    : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Nama
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.punishment_discipline_employee_name !== "" ? this.state.detail.punishment_discipline_employee_name : '-'}</>
                                                    : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Pangkat
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.punishment_discipline_employee_rank !== "" ? this.state.detail.punishment_discipline_employee_rank : '-'}</>
                                                    : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Jabatan
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.punishment_discipline_employee_position !== "" ? this.state.detail.punishment_discipline_employee_position : '-'}</>
                                                    : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Unit Kerja
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.punishment_discipline_employee_work_unit !== "" ? this.state.detail.punishment_discipline_employee_work_unit : '-'}</>
                                                    : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>

                                        <hr />

                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                # Atasan langsung
                                            </label>
                                        </Row>

                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                NIP
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.punishment_discipline_head_employee_nip !== "" ? this.state.detail.punishment_discipline_head_employee_nip : '-'}</>
                                                    : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Nama
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.punishment_discipline_head_employee_name !== "" ? this.state.detail.punishment_discipline_head_employee_name : '-'}</>
                                                    : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Pangkat
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.punishment_discipline_head_employee_rank !== "" ? this.state.detail.punishment_discipline_head_employee_rank : '-'}</>
                                                    : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Jabatan
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.punishment_discipline_head_employee_position !== "" ? this.state.detail.punishment_discipline_head_employee_position : '-'}</>
                                                    : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>

                                        <hr />

                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Upload Surat Pemanggilan
                                            </label>
                                            <Col md="4">
                                                <FileInput
                                                    name="file_sp"
                                                    col="4"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Col md="2"></Col>
                                            <Col md="9">
                                                <Link to="?">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/hukuman_disiplin.html?'/>
                : null }
            </Fragment>
        )
    }

}

//export default IndexView
export default withRouter(IndexView);